import { isMock } from '../config'
import { enlaceMock } from './mock'
import { enlaceReal } from './real'
import type { EnlaceService } from './types'

export const enlaceService: EnlaceService = isMock('enlace') ? enlaceMock : enlaceReal
export type { EnlaceService, ResendChannel, ResendRequest } from './types'
